import { TogglesConfiguration } from "../app/core/enum/toggles-configuration.enum";

export const environment = {
  production: true,
  apiUrl: "https://prod-backend.ottoenterprise.com.br",
  appUrl: "https://app.bankermaisdigital.com.br",
  cloudCobanUrl: "https://banker.cobanmaisdigital.com.br",
  isCheckingAccountBitrix: "16447",
  hotjarSiteId: 3435623,
  hotjarVersion: 6
};

const emailsToggle = [
  "rafael.bb@teddydigital.io",
  "rafael.co@teddydigital.io",
  "rafael.adm@teddydigital.io",
  "daniel.felippelli@teddydigital.io",
  "matheus.silva@teddydigital.io",
  "wagner.ferreira@teddydigital.io",
  "leandro.negreiros@teddydigital.io",
  "luis.fernando@teddy360.com.br",
  "luizfernando@teddy360.com.br",
  "matheus@adm.teste",
  "alan.soto@teddydigital.io"
];

export const toggles = [
  {
    key: TogglesConfiguration.CONSULT_SERASA,
    activated: false,
    emails: emailsToggle
  },
  {
    key: TogglesConfiguration.WORKING_CAPITAL,
    activated: true,
    emails: emailsToggle
  },
  {
    key: TogglesConfiguration.FILTERS_KANBAN,
    activated: true,
    emails: emailsToggle
  },
  {
    key: TogglesConfiguration.AMPLIFIQUE_ME,
    activated: false,
    emails: emailsToggle
  },
  {
    key: TogglesConfiguration.CANCEL_PROPOSAL_KANBAN,
    activated: true,
    emails: emailsToggle
  },
  {
    key: TogglesConfiguration.FAQ_ADMIN,
    activated: true,
    emails: [
      ...emailsToggle,
      "valery.oliveira@teddydigital.io",
      "flavia.adm@otto.com",
    ],
  },
  {
    key: TogglesConfiguration.FAQ_MANAGER,
    activated: true,
    emails: [
      ...emailsToggle,
      "valery.oliveira@teddydigital.io",
      "flavia.adm@otto.com",
    ],
  },
  {
    key: TogglesConfiguration.SELECT_API_AT_LOGIN,
    activated: true,
    emails: [],
  },
  {
    key: TogglesConfiguration.MAIS_DIGITAL_PLAY,
    activated: true,
    emails: []
  },
  {
    key: TogglesConfiguration.SWITCH_LGPD_EXTERNAL,
    activated: true,
    emails: emailsToggle,
  },
];
